(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

// import '../../modules/organisms/configurator-hsform/configurator-hsform';

jQuery(document).ready(function () {
  var configData = {
    firstName: '',
    lastName: '',
    email: '',
    zip: ''
  };

  try {
    var data = JSON.parse(localStorage.getItem('configData'));
    if (data) {
      configData = {
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        zip: data.zip || ''
      };
    }
  } catch (e) {}

  jQuery('.model-card').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var redirect = jQuery(this).find('a.btn-begin').attr('href');

    var productId = jQuery(this).attr('prod-id');

    configData.model = productId;

    sessionStorage.setItem('configData', JSON.stringify(configData));
    localStorage.setItem('configData', JSON.stringify(configData));

    var retUrl = redirect + buildURLParams();

    window.location.href = retUrl;
  });
});

},{}]},{},[1]);
